import { useApiClient } from "../../../hooks/useApiClient";
import { type ISelectObject } from "../../../types/select";
import useSWRImmutable from "swr/immutable";
import { type ICommercialRequesterTypeResponse } from "../types";

interface IUseCommercialRequesterTypeReturnType {
  requesterTypeOptions: ISelectObject[];
  isLoading: boolean;
  isError: boolean;
}

/**
 * 商業登記 種別（requester-type）を取得するカスタムフック
 */
export const useCommercialRequesterType =
  (): IUseCommercialRequesterTypeReturnType => {
    const { apiClient } = useApiClient();

    const fetcher = async (
      url: string
    ): Promise<ICommercialRequesterTypeResponse> => {
      const { data } = await apiClient.get<ICommercialRequesterTypeResponse>(
        url
      );
      return data;
    };

    const toSelectObjectList = (
      data: ICommercialRequesterTypeResponse | undefined
    ): ISelectObject[] => {
      if (data === undefined) return [];

      return data.list.map((item) => ({
        value: item.id.toString(),
        label: item.name,
      }));
    };

    const { data, error, isLoading } = useSWRImmutable<
      ICommercialRequesterTypeResponse,
      Error
    >("option/commercial/requester-type", fetcher);

    return {
      requesterTypeOptions: toSelectObjectList(data),
      isLoading,
      isError: Boolean(error),
    };
  };
